<div
  class="cv-selector-main"
  id="topOfReview"
>
  <!-- Left: Selected CV Preview -->
  <div class="cv-preview-section">
    <div
      #cvToDownload
      class="cv-full-view"
    >
      <ng-container [ngSwitch]="selectedTemplate">
        <app-template1
          *ngSwitchCase="'template1'"
          [data]="resumeData"
        ></app-template1>
        <app-template2
          *ngSwitchCase="'template2'"
          [data]="resumeData"
        ></app-template2>
        <app-template3
          *ngSwitchCase="'template3'"
          [data]="resumeData"
        ></app-template3>
        <app-template4
          *ngSwitchCase="'template4'"
          [data]="resumeData"
        ></app-template4>
        <app-template5
          *ngSwitchCase="'template5'"
          [data]="resumeData"
        ></app-template5>
        <app-template6
          *ngSwitchCase="'template6'"
          [data]="resumeData"
        ></app-template6>
        <app-template7
          *ngSwitchCase="'template7'"
          [data]="resumeData"
        ></app-template7>
        <app-template8
          *ngSwitchCase="'template8'"
          [data]="resumeData"
        ></app-template8>
        <app-template9
          *ngSwitchCase="'template9'"
          [data]="resumeData"
        >
        </app-template9>
        <app-template10
          *ngSwitchCase="'template10'"
          [data]="resumeData"
        >
        </app-template10>
        <app-template11
          *ngSwitchCase="'template11'"
          [data]="resumeData"
        >
        </app-template11>
        <app-template12
          *ngSwitchCase="'template12'"
          [data]="resumeData"
        >
        </app-template12>
      </ng-container>
    </div>
    <!-- PAYSTACK BUTTON -->
    <button
      class="download-btn"
      angular4-paystack
      [disabled]="isProcessingPayment"
      [key]="paystackKey"
      [email]="resumeData?.contactDetails?.email"
      [amount]="5000 * 100"
      [ref]="transactionRef"
      (onClose)="paymentCancel()"
      (callback)="paymentDone($event)"
    >
      {{ isProcessingPayment ? 'PROCESSING...' : 'Pay to Download CV' }}
    </button>
  </div>

  <!-- Right: CV Template Thumbnails -->
  <div class="cv-thumbnails-section">
    <h3>Select A Template</h3>
    <div class="cv-thumbnail-grid">
      <div
        class="cv-thumb"
        *ngFor="let template of templates"
        (click)="selectTemplate(template.id)"
        [class.selected]="selectedTemplate === template.id"
      >
        <ng-container [ngSwitch]="template.id">
          <app-template1
            *ngSwitchCase="'template1'"
            [data]="resumeData"
            isThumbnail="true"
          ></app-template1>
          <app-template2
            *ngSwitchCase="'template2'"
            [data]="resumeData"
            isThumbnail="true"
          ></app-template2>
          <app-template3
            *ngSwitchCase="'template3'"
            [data]="resumeData"
            isThumbnail="true"
          ></app-template3>
          <app-template4
            *ngSwitchCase="'template4'"
            [data]="resumeData"
            isThumbnail="true"
          ></app-template4>
          <app-template5
            *ngSwitchCase="'template5'"
            [data]="resumeData"
            isThumbnail="true"
          ></app-template5>
          <app-template6
            *ngSwitchCase="'template6'"
            [data]="resumeData"
            isThumbnail="true"
          ></app-template6>
          <app-template7
            *ngSwitchCase="'template7'"
            [data]="resumeData"
            isThumbnail="true"
          >
          </app-template7>
          <app-template8
            *ngSwitchCase="'template8'"
            [data]="resumeData"
            isThumbnail="true"
          >
          </app-template8>
          <app-template9
            *ngSwitchCase="'template9'"
            [data]="resumeData"
            isThumbnail="true"
          >
          </app-template9>
          <app-template10
            *ngSwitchCase="'template10'"
            [data]="resumeData"
            isThumbnail="true"
          >
          </app-template10>
          <app-template11
            *ngSwitchCase="'template11'"
            [data]="resumeData"
            isThumbnail="true"
          >
          </app-template11>
          <app-template12
            *ngSwitchCase="'template12'"
            [data]="resumeData"
            isThumbnail="true"
          >
          </app-template12>
        </ng-container>
      </div>
    </div>
  </div>
</div>
